// extracted by mini-css-extract-plugin
export default {"bannerDiv":"EventBanner_bannerDiv__izYKb","bannerImg":"EventBanner_bannerImg__rqrGI","deleteIcon":"EventBanner_deleteIcon__KXT0N"};